/*
  [PELS] Backseat Protector
  nextdev-page-luxurious-full-backseat.js
  Reason videos play muted while on screen and pause when off screen. With reduced motion turned on,
  they stay paused and show controls instead.
  YouTube: same as the Instant page. The thumbnail is swapped for the player in the same spot when
  play is pressed, with the same embed address Instant used.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObserver = null;

  function getObserver() {
    if (videoObserver || !('IntersectionObserver' in window)) return videoObserver;
    videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    return videoObserver;
  }

  function initVideo(v) {
    if (v.getAttribute('data-nextdev-lfb-ready') === 'true') return;
    v.setAttribute('data-nextdev-lfb-ready', 'true');
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');

    if (reduceMotion) {
      v.removeAttribute('autoplay');
      v.pause();
      v.controls = true;
      return;
    }

    var io = getObserver();
    if (io) {
      v.removeAttribute('autoplay');
      v.pause();
      io.observe(v);
    }
  }

  function initYouTube(el) {
    if (el.getAttribute('data-nextdev-lfb-ready') === 'true') return;
    el.setAttribute('data-nextdev-lfb-ready', 'true');

    var button = el.querySelector('button');
    var id = el.getAttribute('data-nextdev-lfb-yt');
    if (!button || !id) return;

    button.addEventListener('click', function () {
      var vid = encodeURIComponent(id);
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + vid + '?v=' + vid +
        '&autoplay=1&color=white&enablejsapi=1&state=1&modestbranding=1&loop=0&rel=0&playsinline=1';
      iframe.title = el.getAttribute('data-title') || '';
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      el.replaceChild(iframe, button);
    });
  }

  function init(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll('.nextdev-lfb video.nextdev-lfb__video, video.nextdev-lfb__video');
    for (var i = 0; i < videos.length; i++) initVideo(videos[i]);
    var players = root.querySelectorAll('[data-nextdev-lfb-yt]');
    for (var j = 0; j < players.length; j++) initYouTube(players[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor: re-init when the section is added or reloaded */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
